import { Edit } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ActionsItemProps } from './actions'

export const EditProposal = ({ order, disabled }: ActionsItemProps) => {
  const navigation = useNavigate()

  return (
    <MenuItem
      onClick={() => navigation(`/orders/web/${order.proposalId}/edit`)}
      disableRipple
      disabled={disabled}
    >
      <Edit />
      Editar
    </MenuItem>
  )
}
